





































































































































import Vue from 'vue';
import { FormFieldValidation, ModalHelpers, RouteHelpers } from '@/mixins';
import { BaseResultModel, DocuSignAdditionalDocumentSignTabCreateUpdateModel, ValueType } from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'DocusignAddAdditionalDocumentSignTab',
  mixins: [FormFieldValidation, ModalHelpers, RouteHelpers],
  data() {
    return {
      isLoading: false,
      additionalDocumentSignTab: {} as DocuSignAdditionalDocumentSignTabCreateUpdateModel,
      submitIsLoading: false
    };
  },
  methods: {
    async onSubmit(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (!isValid) {
          return;
        }
      } catch (error) {
        this.$log('Validation failed', error);
        return;
      }

      this.submitIsLoading = true;
      try {
        const result: BaseResultModel = await DocuSignConfigurationService.createAdditionalDocumentSignTabAsync(this.$route.params.id, this.additionalDocumentSignTab);
        if (result.hasNotification && !result.showToast) {
          this.addFormValidationError(result.notification);
          this.submitIsLoading = false;
          return;
        }
        SnotifyConfiguration.showSuccess('Sign tab created successfully.');
        this.setApplicationDirty(false);
        this.navigateToSignTabManagement();
      } catch (error) {
        this.$log('Error creating sign tab');
      } finally {
        this.submitIsLoading = false;
      }
    },
    async onCancel(this: any) {
      this.navigateToSignTabManagement();
    },
    resetValidation(this: any) {
      this.$validator.reset();
      this.resetFormValidation();
    },
    navigateToSignTabManagement(this: any) {
      this.navigateToRoute('docusignAdditionalDocumentSignTabManagement', this.$route.params.id);
    }
  },
  created(this: any) {
    this.pageNumberValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 1,
      maxValue: 100
    } as ValidationModel;
    this.coordValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 0,
      maxValue: 10000
    } as ValidationModel;
  },
  components: {
    LoadingSpinner
  }
});
